import { Injectable } from '@angular/core'

import { OperationServiceAdapter } from './../operation'
import { JsonApiProcessor } from './../operation/operation-processors/json-api-processor'
import { ExamReport } from '../../models'

@Injectable()
export class ExamReportService extends OperationServiceAdapter<ExamReport> {
  constructor(_processor: JsonApiProcessor) {
    super(_processor, ExamReport)
  }

  public generate(executionIds: number[], params?: { [key: string]: any }, includes?: string[], filters?: string[]) {
    return this.callPostOperation(
      'generate',
      Object.assign({ params: params || {} }, { args: { executionIds: executionIds } }),
      includes,
      filters
    )
  }

  public generateReportByCriteria(criteria: Array<{}>, reportType: string, includes?: string[], filters?: string[]) {
    return this.callPostOperation(
      'generate_by_criteria',
      { criteria: {criteria: criteria}, reportType: {type: reportType} },
      includes,
      filters
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/exam-report/exam-report.service.ts